import { ITenantService } from "@/services/tenant-service/IResourceService.ts";
import { SearchResponse } from "@/services/entities/AxiosMethod.ts";
import { TenantInfo } from "@/services/tenant-service/entities/TenantEntity.ts";
import { baseUrlApi, BuildURLWithTenantId } from "@/commons/RootURL.ts";
import { HttpClientNormal } from "@/services/entities/HttpClient.ts";
import { AxiosResponse } from "axios";

export class TenantService implements ITenantService {
  private _httpClient: HttpClientNormal = new HttpClientNormal()

  getTenantList(endpoint: string): Promise<SearchResponse<TenantInfo>> {
    const url = `${BuildURLWithTenantId(
      baseUrlApi
    )}tenants${endpoint}`;
    return this._httpClient.get(url)
      .then((response: AxiosResponse) => new SearchResponse<TenantInfo>(response, TenantInfo))
      .catch((err) => new SearchResponse<TenantInfo>(err?.response))
  }
}